import React from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

const MODERN_RESULTS_PATH = '/new-resultats-equipes';

/** Ancienne liste clone → interface moderne (conserve les query params). */
export function RedirectCloneListToModern() {
	const location = useLocation();
	return <Navigate to={`${MODERN_RESULTS_PATH}${location.search}`} replace />;
}

/** Ancienne fiche équipe → ?team=… sur l’interface moderne. */
export function RedirectCloneTeamToModern() {
	const { teamNumber } = useParams();
	const [searchParams] = useSearchParams();
	const params = new URLSearchParams(searchParams);
	params.set('team', teamNumber);
	return <Navigate to={`${MODERN_RESULTS_PATH}?${params.toString()}`} replace />;
}

/** Ancienne fiche joueur → ?joueur=… sur l’interface moderne. */
export function RedirectClonePlayerToModern() {
	const { licence } = useParams();
	const [searchParams] = useSearchParams();
	const params = new URLSearchParams(searchParams);
	params.set('joueur', licence);
	params.set('tab', 'joueurs');
	return <Navigate to={`${MODERN_RESULTS_PATH}?${params.toString()}`} replace />;
}
